module.exports = __webpack_public_path__ + "static/media/boomreader-logo.b9e6e560.svg";